<template>
  <div class="package-edit-form-container ml-10">
    <app-filter
      :filter-list="table_filter"
      default-label-width="100px"
      @search="search"
    />
    <div class="text-right">
      <el-button size="mini" type="success" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app_table_ref"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getSiteList"
      :table-props="{
        'max-height': '450px',
      }"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getSiteListApi, pullSiteListApi } from '@/api/tool/site';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  name: 'SiteList',
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 模块表单配置 */
    formFields: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 分配的落地页数据 */
    assignSelection: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs['app_table_ref'].seekTable();
    },
    /**
     * 获取落地页列表
     * @param {Object} params 接口参数
     */
    getSiteList(params) {
      return new Promise((resolve) => {
        const { name, ...rest } = params;
        const { campaign_config } = this.local_sharing_data.getFormFields();
        const { delivery_form } = campaign_config.config;
        const { delivery_platform_type, delivery_content_id } = delivery_form.config;
        const { channel_interface } = this.getInitConfig();
        const strategy = {
          [CHANNEL_INTERFACE_TYPE.GDT]: () => {
            return {
              ...(delivery_content_id.value && { delivery_content_id: delivery_content_id.value.split('#')[0] }),
            };
          },
          [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
            const result_map = delivery_content_id.value.result_map;
            return {
              ...((delivery_platform_type.value === '2' && Object.keys(result_map).length && result_map[this.advertiserId]) && { delivery_content_id: result_map[this.advertiserId].value.split('#')[0] }),
            };
          },
          default: () => {
            const result_map = delivery_content_id.value.result_map;
            return {
              ...((Object.keys(result_map).length && result_map[this.advertiserId]) && { delivery_content_id: result_map[this.advertiserId].value.split('#')[0] }),
            };
          },
        };
        const filtering = {
          ...(name && { name }),
          ...((strategy[channel_interface] || strategy.default)()),
        };
        getSiteListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          filtering,
          ...rest,
        }).then(res => {
          res.list.forEach(item => Object.assign(item, { advertiser_id: this.advertiserId }));
          resolve(res);
        });
      });
    },
    /** 同步落地页列表 */
    onPull() {
      const { channel_interface } = this.getInitConfig();
      pullSiteListApi({ channel_interface, advertiser_id: this.advertiserId }).then((res) => {
        this.$message.success(res.message || '同步成功');
        this.$refs['app_table_ref'].seekTable();
      });
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      this.assignSelection.splice(0);
      this.assignSelection.push(...rows);
    },
    /** 获取初始化配置 */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.log(error);
        return {};
      }
    },
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      return Promise.resolve(this.assignSelection);
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const list = this.formFields.selection_config.list.filter((item) => String(item.advertiser_id) === String(this.advertiserId));
      const app_table_ref = this.$refs.app_table_ref;

      this.assignSelection.splice(0);
      this.assignSelection.push(...list);

      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...this.assignSelection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...this.assignSelection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
  },
};
</script>
